import React from "react";
import { View, Text } from "@react-pdf/renderer";

const pointsCont = (styles: React.CSSProperties | any): JSX.Element => (
    <View style={styles.earnPoints}>
        <Text> Order online to earn rewards </Text>
    </View>
);
export default pointsCont;
